import { Camera, Plane, Raycaster, Vector2, Vector3 } from 'three';

export const fromPointer = (
  raycaster: Raycaster,
  pointer: Vector2,
  plane: Plane,
  camera: Camera,
  target: Vector3 = new Vector3()
) => {
  raycaster.setFromCamera(pointer, camera);
  raycaster.ray.intersectPlane(plane, target);
  return target;
};
